import { render } from "./NNotFoundImage.vue?vue&type=template&id=453737ee&ts=true"
import script from "./NNotFoundImage.vue?vue&type=script&lang=ts"
export * from "./NNotFoundImage.vue?vue&type=script&lang=ts"

import "./NNotFoundImage.vue?vue&type=style&index=0&id=453737ee&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__